import defaultAttributes from '../defaultAttributes';

const SmartphoneCharging = [
  'svg',
  defaultAttributes,
  [
    ['rect', { x: '5', y: '2', width: '14', height: '20', rx: '2', ry: '2' }],
    ['path', { d: 'M12.667 8L10 12h4l-2.667 4' }],
  ],
];

export default SmartphoneCharging;
